import React, { useEffect, useState, useMemo } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import sponsorService from '../../services/sponsorService';
import championshipService from '../../services/championshipService';
import useAuth from '../../hooks/useAuth';
import './SponsorList.css';

function SponsorList() {
  const { user } = useAuth();
  const params = useParams();
  const championshipId = params.id || params.championshipId;
  const [championship, setChampionship] = useState(null);
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!championshipId) {
      setLoading(false);
      setError('ID do campeonato não encontrado na URL.');
      return;
    }

    // 🔹 Carregar informações do campeonato
    championshipService
      .getById(championshipId)
      .then((res) => setChampionship(res.data || res))
      .catch(() => setError('Erro ao carregar campeonato.'));

    // 🔹 Carregar patrocinadores
    sponsorService
      .listByChampionship(championshipId)
      .then((response) => setSponsors(response.data))
      .catch((err) => {
        console.error('Erro ao buscar patrocinadores:', err);
        setError('Não foi possível carregar os patrocinadores.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [championshipId]);

  // 🔹 Verifica se usuário é criador ou gestor
  const canManageSponsors = useMemo(() => {
    if (!user || !championship) return false;
    const userId = user._id;
    const isCreator = championship.creator?._id === userId;
    const isManager = championship.managers?.some((m) => m._id === userId);
    return isCreator || isManager;
  }, [user, championship]);

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este patrocinador?')) return;

    try {
      await sponsorService.delete(id);
      setSponsors((prev) => prev.filter((s) => s._id !== id));
    } catch (err) {
      console.error('Erro ao excluir patrocinador:', err);
      alert('Erro ao excluir patrocinador.');
    }
  };

  return (
    <div className="sponsor-container">
      <button onClick={() => navigate(-1)} className="sponsor-back-button">
        ← Voltar
      </button>

      <div className="sponsor-header">
        <h3>Patrocinadores</h3>

        {/* Apenas criador/gestores podem cadastrar */}
        {canManageSponsors && (
          <Link
            to={`/championships/${championshipId}/sponsors/new`}
            className="btn-add-sponsor"
          >
            + Cadastrar Patrocinador
          </Link>
        )}
      </div>

      {loading && <p>Carregando patrocinadores...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {!loading && !error && (
        <>
          {sponsors.length === 0 ? (
            <p>Nenhum patrocinador associado a este campeonato.</p>
          ) : (
            <div className="sponsor-list">
              {sponsors.map((s) => (
                <div key={s._id} className="sponsor-card">
                  {/* Apenas criador/gestores podem excluir */}
                  {canManageSponsors && (
                    <button
                      onClick={() => handleDelete(s._id)}
                      title="Excluir"
                      className="delete-sponsor-btn"
                    >
                      ×
                    </button>
                  )}

                  <a href={s.link || '#'} target="_blank" rel="noopener noreferrer">
                    <img
                      src={`${(process.env.REACT_APP_API_URL || 'http://localhost:5000').replace('/api', '')}/uploads/${s.image}`}
                      alt={s.name}
                      className="sponsor-image"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = 'none';
                      }}
                    />
                  </a>
                  <p className="sponsor-name">{s.name}</p>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default SponsorList;
